import { OnChanges, Component, OnInit, Input, SimpleChanges, SimpleChange } from '@angular/core';
import { ApiService } from './../../services/api.service';
import { QuestionsService } from './../../services/questions.service';
import { TranslatesService } from './../../services/translates.service';

@Component({
  selector: 'stg-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss']
})
export class QuestionComponent implements OnInit, OnChanges {

  public _objectId: number;
  @Input() set objectId(value: string) {
    if (typeof this.questionsService.data[value] === 'undefined' || this.questionsService.data[value] === null) {
      this.getRandQuestion(value);
    } else {
      this.getQuestion(this.questionsService.data[value].questionId);
    }
    this._objectId = +value;
  }
  @Input() tripId =  -1;
  public question: any = {};
  private questionTemp = null;
  constructor(private apiService: ApiService, private questionsService: QuestionsService, public translate: TranslatesService) { }

  ngOnInit() {
  }

  public getRandQuestion(objectId) {
    this.apiService.getRandQuestion(objectId).subscribe(
        (res: any) => {
          this.questionTemp = res.data;
        },
        err => console.log('ERROR', err), // error
        () => {
          if (typeof this.questionTemp !== 'undefined') {
            this.question = this.questionTemp;
            this.questionsService.add(this.tripId, this._objectId, this.question.id);
          }
        }
    );
  }

  public checkAnswer(questionId, answerId) {
    this.apiService.getCheckAnswer(questionId, answerId).subscribe(
      (res: any) => {

      },
      err => console.log(err), // error
      () => {

      }
    );
  }

  public getQuestion(questionId) {
    this.apiService.getQuestion(questionId).subscribe(
        (res: any) => {
            this.questionTemp = res.data;
        },
        err => console.log('ERROR', err), // error
        () => {
          if (typeof this.questionTemp !== 'undefined') {
            this.question = this.questionTemp;
            if (this.questionsService.data[this._objectId] !== undefined && this.questionsService.data[this._objectId] !== null) {
              if (this.questionsService.data[this._objectId].answerId === null) {
                this.questionsService.add(this.tripId, this._objectId, this.question.id);
              }
            }
          }
        }
    );
  }

  public checkQuestion(questionId, answerId) {
    this.apiService.checkAnswer(questionId, answerId).subscribe(
        (res: any) => {
          this.questionsService.add(this.tripId, this._objectId, questionId, answerId, res.data.result);
        },
        err => console.log('ERROR', err), // error
        () => { }
    );
  }

  public saveAnswer(answerId) {
    this.checkQuestion(this.question.id, answerId);
  }

  public isQuestionAnswered() {
    if (this.questionsService.data[this._objectId] !== undefined && this.questionsService.data[this._objectId] !== null) {
      if (this.questionsService.data[this._objectId].answerId !== null) {
        return true;
      }
    }
    return false;
  }

  public isAnswerGood() {
    if (this.questionsService.data[this._objectId] !== undefined && this.questionsService.data[this._objectId] !== null) {
      if (this.questionsService.data[this._objectId].answerId !== null) {
        return this.questionsService.data[this._objectId].good === true ? true : false;
      }
    }
    return false;
  }

  ngOnChanges(changes: SimpleChanges) {

  }

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/shared-components/question/question.component.ts